/* ============================================================
   SPORTIVE MEGA MENU
   ============================================================ */

(function () {
  'use strict';

  function initMegaMenu() {
    const mega = document.getElementById('sportive-mega');
    if (!mega) return;

    const triggers = document.querySelectorAll('[data-sportive-trigger]');
    if (!triggers.length) return;

    let closeTimer = null;

    function setExpanded(li, value) {
      const link = li.querySelector('a');
      if (link) link.setAttribute('aria-expanded', value ? 'true' : 'false');
    }

    function openPanel(panelId, triggerLi) {
      clearTimeout(closeTimer);
      // Reset all
      mega.querySelectorAll('.sportive-mega__inner').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('inert', '');
      });
      triggers.forEach(function (li) { setExpanded(li, false); });

      const panel = mega.querySelector('[data-panel="' + panelId + '"]');
      if (panel) {
        panel.classList.add('is-active');
        panel.removeAttribute('inert');
        mega.classList.add('is-open');
        if (triggerLi) setExpanded(triggerLi, true);
      } else {
        mega.classList.remove('is-open');
      }
    }

    function closeMenu(immediate) {
      function doClose() {
        mega.classList.remove('is-open');
        mega.querySelectorAll('.sportive-mega__inner').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('inert', '');
        });
        triggers.forEach(function (li) {
          li.classList.remove('is-open');
          setExpanded(li, false);
        });
      }
      if (immediate) {
        doClose();
      } else {
        closeTimer = setTimeout(doClose, 150);
      }
    }

    // Set all panels inert initially
    mega.querySelectorAll('.sportive-mega__inner').forEach(function (p) {
      p.setAttribute('inert', '');
    });

    triggers.forEach(function (li) {
      const panelId = li.dataset.sportiveTrigger;
      const link = li.querySelector('a');

      // Click: first click opens panel, second click follows the link
      if (link) {
        link.addEventListener('click', function (e) {
          const isOpen = mega.classList.contains('is-open') &&
            mega.querySelector('[data-panel="' + panelId + '"].is-active');
          if (!isOpen) {
            e.preventDefault();
            openPanel(panelId, li);
            li.classList.add('is-open');
          }
        });

        // Enter/Space opens panel, then arrow-down moves focus into it
        link.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            const isOpen = mega.classList.contains('is-open') &&
              mega.querySelector('[data-panel="' + panelId + '"].is-active');
            if (!isOpen) {
              e.preventDefault();
              openPanel(panelId, li);
              li.classList.add('is-open');
            }
          }
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            const panel = mega.querySelector('[data-panel="' + panelId + '"]');
            if (panel) {
              const firstLink = panel.querySelector('a');
              if (firstLink) firstLink.focus();
            }
          }
        });
      }

      li.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        li.classList.add('is-open');
        openPanel(panelId, li);
      });

      li.addEventListener('mouseleave', function () {
        li.classList.remove('is-open');
        closeMenu(false);
      });
    });

    // Keep open when hovering the mega panel itself
    mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    mega.addEventListener('mouseleave', function () { closeMenu(false); });

    // Trap focus inside panel: Escape returns focus to trigger
    mega.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const activePanel = mega.querySelector('.sportive-mega__inner.is-active');
        const panelId = activePanel && activePanel.dataset.panel;
        closeMenu(true);
        if (panelId) {
          const trigger = document.querySelector('[data-sportive-trigger="' + panelId + '"] a');
          if (trigger) trigger.focus();
        }
      }
    });

    // Close on Escape at document level too
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mega.classList.contains('is-open')) {
        closeMenu(true);
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
      if (!mega.contains(e.target) && !e.target.closest('[data-sportive-trigger]')) {
        closeMenu(true);
      }
    });

    // Close when focus leaves the mega area entirely
    document.addEventListener('focusin', function (e) {
      const inTrigger = e.target.closest('[data-sportive-trigger]');
      const inMega = mega.contains(e.target);
      if (!inTrigger && !inMega) {
        closeMenu(true);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initMegaMenu);
})();
